<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>疗养预约系统</el-breadcrumb-item>
        <el-breadcrumb-item>公告信息</el-breadcrumb-item>
        <el-breadcrumb-item>发布公告</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="hx-form-container box-shadow">
      <el-form :model="listParams" v-loading="tableLoading" :rules="checklistParams">
        <el-form-item label="公告标题：">
          <el-input v-model="listParams.title" size="small" placeholder="输入标题" style="width: 200px"> </el-input>
        </el-form-item>

        <el-form-item label="公告内容：" prop="description" style="height: 650px">
          <RichTextarea class="wang-editor-style" v-model="listParams.content" height="540px" />
        </el-form-item>

        <el-form-item class="align-center mgt10" style="padding-bottom: 20px; margin-top: 20px">
          <el-button size="small" type="primary" @click="saveAdd()"> 保存 </el-button>
          <el-button size="small" class="mgl20" @click="backToList">返回</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableLoading: false,
      listParams: {
        title: "",
        content: "",
      },
      checklistParams: {
        title: [{ required: true, message: "请填写标题", trigger: "blur" }],
        content: [{ required: true, message: "请输入内容", trigger: "blur" }],
      },
    };
  },
  mounted() {},
  methods: {
    backToList: function () {
      this.$router.push({
        name: "convalescenceNotice",
      });
    },
    saveAdd: function () {
      if (this.listParams.content.trim().length > 255) {
        this.$message({
          message: "内容不能为超过255个字符",
          type: "error",
        });
        return;
      }
      this.tableLoading = true;
      if (this.listParams.title.trim().length != 0 && this.listParams.content.trim().length != 0) {
        const bodyParams = Object.assign(
          {},
          {
            title: this.listParams.title,
            content: this.listParams.content,
          }
        );
        this.$http({
          url: global.apiUrl + "/recuperate/notice/publish",
          method: "POST",
          params: bodyParams,
        })
          .then(res => {
            if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
              this.tableLoading = false;
              if (res.body.data) {
                this.$message({
                  message: res.body.info,
                  type: "success",
                });
                this.$router.push({
                  name: "convalescenceNotice",
                });
              } else {
                this.tableData = [];
              }
            } else {
              this.tableLoading = false;
              this.$message({
                message: res.body.info,
                type: "error",
              });
            }
          })
          .catch(err => {
            this.tableLoading = false;

            console.error(err);
          });
      } else {
        this.tableLoading = false;
        this.$message({
          message: "标题或者内容不能为空",
          type: "error",
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.el-checkbox-group {
  width: 625px;
}
.el-checkbox:nth-child(5n + 1) {
  margin-left: 0;
}

.hx-form-container {
  .spec-unit-style {
    .el-form-item__content {
      margin-left: 10px !important;
    }
  }
  .wang-editor-style {
    width: 60vw;
    margin-top: 10px;
    float: left;
  }
  .upload-thumbnail-img,
  .thumbnail-img {
    width: 100px;
    height: 50px;
    border: 1px solid #ebeef5;
    position: relative;
    overflow: hidden;
    margin-left: 10px;
    .upload-icon {
      font-size: 20px;
      display: inline-block;
      margin-top: 15px;
      margin-left: 40px;
    }
    .hidden-upload {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      opacity: 0;
      filter: alpha(opacity=0); //filter 过滤器   兼容IE678
      z-index: 2;
      cursor: pointer;
    }
    .thumbnail-img-wrapped {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
    }
    .combined-img {
      position: relative;
      width: 100px;
      height: 50px;
      .hover-img {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        z-index: 999;
        opacity: 0;
        .close-btn {
          font-size: 22px;
          color: #fff;
          position: absolute;
          left: 50%;
          margin-left: -11px;
          top: 50%;
          margin-top: -11px;
        }
      }
      .hover-img:hover {
        opacity: 1;
        cursor: pointer;
        background-color: rgba(0, 0, 0, 0.5);
      }
    }
  }
  .wrap-thumbnail-img {
    width: 100%;
    height: 50px;
    margin-top: 10px;
    display: flex;
  }
}
</style>
